export function simpleTransformer(response) {
  return response
}

export function defaultDataTransformer(response) {
  return response.json().then(result => result)
}

export function fetcher(resource, init = {}) {
  return fetch(resource, init)
}

export function transformDataFetcher(f, transformer) {
  return function func(...args) {
    return f.apply(this, args).then(transformer)
  }
}

export function raiseHttpErrorTransformer(response) {
  if (!response.ok) {
    throw response
  }
  return response
}



// WEBPACK FOOTER //
// ./src/js/resources/transformer.js